var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.displayedAvailability)?_c('div',{staticClass:"bc-user-availability"},[_c('div',{staticClass:"bcx-dot c-dot-availability",class:`c-dot-availability--${_setup.mode}`}),_vm._t("default",null,{"mode":_setup.mode,"label":_setup.label,"when":_setup.when})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }